import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { setDropAPin } from "store/appSlice";
import { useSelector, useDispatch } from "react-redux";
import visitorsToPointSource from "data/sources/visitorsToPointSource";
import { VISITORS_TO_POINT_LAYER_ID } from "components/layers/VisitorsToPointLayer";
import { _FilterTypes as FilterTypes } from "@carto/react-core";
import { useEffect } from "react";
import {
  addLayer,
  removeLayer,
  addSource,
  removeSource,
  addFilter,
  removeFilter,
  updateLayer,
} from "@carto/react-redux";
import { updateSource } from "data/models/updateSource";
import {
  getMinMaxQuantilesEngland,
  getVisitorsEngland,
  getWeeklyData,
  getDailyData,
} from "data/models/model";
import { VISUALS } from "data/config.js";
import { setVisitors, setBreaks, setDay, setWindow } from "store/appSlice";
import {
  LEGEND_TYPES,
  HistogramWidgetUI,
  WrapperWidgetUI,
  TimeSeriesWidgetUI,
  FormulaWidgetUI,
} from "@carto/react-ui";
import {
  FormControl,
  MenuItem,
  Typography,
  InputLabel,
  Select,
  Divider,
  Link,
  Button,
} from "@material-ui/core";
import { numberFormatter } from "utils/formatter";
import { useState } from "react";
import { GroupDateTypes } from "@carto/react-core";
import { getTimeseriesData } from "utils/timeSeriesGenerator";

const useStyles = makeStyles(() => ({
  newComponents: {
    marginTop: 12,
    marginBottom: 12,
  },
  intro: {
    marginTop: 20,
    marginBottom: 12,
    marginLeft: 50,
    marginRight: 50,
    lineHeight: 2,
  },
  text: {
    marginTop: 12,
    marginBottom: 12,
  },
  grid: {
    marginTop: 15,
    marginBottom: 18,
    lineHeight: 2,
  },
  buttons: {
    marginLeft: "20%",
    width: "60%",
    height: "40px",
    marginTop: 10,
    marginBottom: 10,
  },
  wrapperLeft: {
    "& .makeStyles-root-29 h6": {
      textAlign: "left",
    },
  },
}));

export default function DropAPin() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const isoline = useSelector((state) => state.app.isoline);
  const day = useSelector((state) => state.app.day);
  const window = useSelector((state) => state.app.window);
  const BUCKETS = VISUALS.buckets;
  const n_visitors = useSelector((state) => state.app.n_visitors);
  const credentials = useSelector((state) => state.carto.credentials);
  const [weeklyData, setWeeklyData] = useState([]);
  const [dailyData, setDailyData] = useState([]);

  //Timeseries
  const [timeseriesVisitors, setTimeseriesVisitors] = useState([]);
  const [avgTimeseriesVisitors, setAvgTimeseriesVisitors] = useState([]);
  const [
    variationMonthTimeseriesVisitors,
    setVariationMonthTimeseriesVisitors,
  ] = useState([]);
  const [variationTimeseriesVisitors, setVariationTimeseriesVisitors] =
    useState([]);

  // [hygen] Add useEffect

  function handleDayChange(e) {
    var value = e.target.value;
    dispatch(setDay(value));
  }

  function handleWindowChange(e) {
    var value = e.target.value;
    dispatch(setWindow(value));
  }

  function average(array) {
    return array.reduce((a, b) => a + b) / array.length;
  }

  useEffect(() => {
    if (n_visitors) {
      var series = getTimeseriesData(
        [{ name: 1630454430000, value: n_visitors }],
        24
      );
      setTimeseriesVisitors(series);
    }
  }, [n_visitors]);

  useEffect(() => {
    if (timeseriesVisitors[0]) {
      var timeseriesValues = timeseriesVisitors.map((a) => a.value);
      console.log(average(timeseriesValues));
      setAvgTimeseriesVisitors(average(timeseriesValues));
      setVariationTimeseriesVisitors(
        (100 *
          (n_visitors -
            timeseriesVisitors[timeseriesVisitors.length - 2].value)) /
          timeseriesVisitors[timeseriesVisitors.length - 2].value
      );
      setVariationMonthTimeseriesVisitors(
        (100 * (n_visitors - average(timeseriesValues))) /
          average(timeseriesValues)
      );
      console.log(average(timeseriesValues));
    }
  }, [timeseriesVisitors, n_visitors]);

  useEffect(() => {
    if (isoline.data) {
      getVisitorsEngland({
        credentials,
        day_of_week: day,
        part_of_day: window,
        isoline: isoline,
      }).then((results) => {
        dispatch(setVisitors(results.n_visitors));
      });
    }
  }, [dispatch, day, window, isoline, credentials]);

  useEffect(() => {
    dispatch(setDropAPin(true));
  }, [dispatch]);

  useEffect(() => {
    if (isoline.data) {
      getWeeklyData({
        credentials,
        day_of_week: day,
        part_of_day: window,
        isoline: isoline,
      }).then((results) => {
        setWeeklyData(results);
      });
    }

    if (isoline.data) {
      getDailyData({
        credentials,
        day_of_week: day,
        part_of_day: window,
        isoline: isoline,
      }).then((results) => {
        setDailyData(results);
      });
    }
  }, [dispatch, day, window, isoline, credentials]);

  useEffect(() => {
    if (isoline.data) {
      getMinMaxQuantilesEngland({
        credentials,
        day_of_week: day,
        part_of_day: window,
        geoid: null,
        buckets: BUCKETS,
        isoline: isoline,
      }).then((results) => {
        dispatch(setBreaks(results[0].quantiles.slice(1)));
        var layerConfig = {
          title: "Number of visitors",
          // changing visible to true will make it show up on the map by default
          visible: true,
          switchable: false,
          legend: {
            attr: VISUALS.attr,
            type: LEGEND_TYPES.BINS,
            labels: results[0].quantiles.slice(1, -1),
            colors: VISUALS.primary_palette,
            collapsible: false,
          },
        };
        dispatch(
          updateLayer({
            id: VISITORS_TO_POINT_LAYER_ID,
            layerAttributes: {
              ...layerConfig,
            },
          })
        );
        dispatch(
          removeFilter({
            id: visitorsToPointSource.id,
            column: "part_of_day",
          })
        );
        dispatch(
          addFilter({
            id: visitorsToPointSource.id,
            column: "part_of_day",
            type: FilterTypes.IN,
            values: window,
            owner: "windowList",
          })
        );
        dispatch(
          removeFilter({
            id: visitorsToPointSource.id,
            column: "day_of_week",
          })
        );
        dispatch(
          addFilter({
            id: visitorsToPointSource.id,
            column: "day_of_week",
            type: FilterTypes.IN,
            values: day,
            owner: "dayList",
          })
        );
      });
    }
    return () => {};
  }, [BUCKETS, credentials, isoline, dispatch, day, window]);

  useEffect(() => {
    if (isoline.data) {
      dispatch(addSource(updateSource(visitorsToPointSource, isoline)));

      getMinMaxQuantilesEngland({
        credentials,
        day_of_week: day,
        part_of_day: window,
        geoid: null,
        buckets: BUCKETS,
        isoline: isoline,
      }).then((results) => {
        dispatch(setBreaks(results[0].quantiles.slice(1)));
        var layerConfig = {
          title: "Number of visitors",
          // changing visible to true will make it show up on the map by default
          visible: true,
          switchable: false,
          legend: {
            attr: VISUALS.attr,
            type: LEGEND_TYPES.BINS,
            labels: results[0].quantiles.slice(1, -1),
            colors: VISUALS.primary_palette,
            collapsible: false,
          },
        };
        dispatch(
          updateLayer({
            id: VISITORS_TO_POINT_LAYER_ID,
            layerAttributes: {
              ...layerConfig,
            },
          })
        );
      });

      dispatch(
        addLayer({
          id: VISITORS_TO_POINT_LAYER_ID,
          source: visitorsToPointSource.id,
        })
      );

      dispatch(
        addFilter({
          id: visitorsToPointSource.id,
          column: "day_of_week",
          type: FilterTypes.IN,
          values: day,
          owner: "dayList",
        })
      );
      dispatch(
        addFilter({
          id: visitorsToPointSource.id,
          column: "part_of_day",
          type: FilterTypes.IN,
          values: window,
          owner: "windowList",
        })
      );
    }

    return () => {
      dispatch(removeLayer(VISITORS_TO_POINT_LAYER_ID));
      dispatch(removeSource(visitorsToPointSource.id));
    };
  }, [dispatch, isoline, BUCKETS, credentials, day, window]);

  if (isoline.data) {
    return (
      <Grid container direction="column" className={classes.dropAPin}>
        <Grid>
          <WrapperWidgetUI
            title="Temporal aggregation"
            className={classes.wrapperLeft}
          >
            <Grid>
              <FormControl className={classes.newComponents}>
                <InputLabel id="simple-label">Weekday</InputLabel>
                <Select
                  labelId="dayListLabel"
                  id="dayList"
                  value={day}
                  onChange={handleDayChange}
                >
                  <MenuItem value={"All"}>All</MenuItem>
                  <MenuItem value={"Monday"}>Monday</MenuItem>
                  <MenuItem value={"Tuesday"}>Tuesday</MenuItem>
                  <MenuItem value={"Wednesday"}>Wednesday</MenuItem>
                  <MenuItem value={"Thursday"}>Thursday</MenuItem>
                  <MenuItem value={"Friday"}>Friday</MenuItem>
                  <MenuItem value={"Saturday"}>Saturday</MenuItem>
                  <MenuItem value={"Sunday"}>Sunday</MenuItem>
                </Select>
              </FormControl>
              <FormControl className={classes.newComponents}>
                <InputLabel id="simple-label">Time of day</InputLabel>
                <Select
                  labelId="windowListLabel"
                  id="windowList"
                  value={window}
                  onChange={handleWindowChange}
                >
                  <MenuItem value={"All"}>All</MenuItem>
                  <MenuItem value={"Morning"}>Morning</MenuItem>
                  <MenuItem value={"Afternoon"}>Afternoon</MenuItem>
                  <MenuItem value={"Evening"}>Evening</MenuItem>
                  <MenuItem value={"Night"}>Night</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </WrapperWidgetUI>
        </Grid>
        <Divider></Divider>
        <WrapperWidgetUI
          title="Visitors this month"
          className={classes.wrapperLeft}
        >
          <Grid className={classes.grid}>
            <FormulaWidgetUI
              data={n_visitors}
              formatter={function formatter(v) {
                return numberFormatter(v);
              }}
            />
            <Typography variant="caption" className={classes.newComponents}>
              visitors to the area
            </Typography>
          </Grid>
          <Divider></Divider>
          <Typography variant="body2" className={classes.newComponents}>
            Visitors weekly distribution
          </Typography>
          <HistogramWidgetUI
            name="STORE"
            data={[
              weeklyData.Monday,
              weeklyData.Tuesday,
              weeklyData.Wednesday,
              weeklyData.Thursday,
              weeklyData.Friday,
              weeklyData.Saturday,
              weeklyData.Sunday,
            ]}
            height="200px"
            yAxisFormatter={function yAxisFormatter(v) {
              return v / 1e3 + "k";
            }}
            dataAxis={["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]}
            selectedBars={[]}
            tooltipFormatter={function tooltipFormatter(params) {
              if (isFinite(params[0].value))
                return numberFormatter(params[0].value) + " visitors";
            }}
          />
          <Typography variant="body2" className={classes.newComponents}>
            Visitors daily distribution
          </Typography>
          <HistogramWidgetUI
            name="STORE"
            data={[
              dailyData.Morning,
              dailyData.Afternoon,
              dailyData.Evening,
              dailyData.Night,
            ]}
            height="200px"
            dataAxis={["Morning", "Afternoon", "Evening", "Night"]}
            yAxisFormatter={function yAxisFormatter(v) {
              return v / 1e3 + "k";
            }}
            selectedBars={[]}
            tooltipFormatter={function tooltipFormatter(params) {
              if (isFinite(params[0].value))
                return numberFormatter(params[0].value) + " visitors";
            }}
            tooltip={true}
          />
        </WrapperWidgetUI>
        <Divider></Divider>
        <WrapperWidgetUI
          title="Visitors evolution"
          className={classes.wrapperLeft}
        >
          <Grid className={classes.grid}>
            <FormulaWidgetUI
              data={avgTimeseriesVisitors}
              formatter={function formatter(v) {
                return numberFormatter(v);
              }}
            />
            <Typography variant="caption" className={classes.newComponents}>
              visitors per month
            </Typography>
            <FormulaWidgetUI
              data={variationMonthTimeseriesVisitors}
              formatter={function formatter(v) {
                return numberFormatter(v) + "%";
              }}
            />
            <Typography variant="caption" className={classes.newComponents}>
              variation last month
            </Typography>
            <FormulaWidgetUI
              data={variationTimeseriesVisitors}
              formatter={function formatter(v) {
                return numberFormatter(v) + "%";
              }}
            />
            <Typography variant="caption" className={classes.newComponents}>
              variation last month over series
            </Typography>
          </Grid>
          <Divider></Divider>
          <Typography variant="subtitle2" className={classes.newComponents}>
            Visitors evolution in time
          </Typography>
          <TimeSeriesWidgetUI
            data={timeseriesVisitors}
            stepSize={GroupDateTypes.MONTHS}
            tooltip={true}
            height="200px"
            formatter={(value) => value.getMonth()}
            tooltipFormatter={function tooltipFormatter(params) {
              if (isFinite(params[0].data[1]))
                var date = new Date(params[0].data[0]);
              return (
                date.toLocaleString("default", { month: "short" }) +
                ": " +
                numberFormatter(params[0].data[1]) +
                " visitors"
              );
            }}
            animation={false}
            showControls={false}
          />
        </WrapperWidgetUI>
      </Grid>
    );
  } else {
    return (
      <Grid container direction="column" className={classes.dropAPin}>
        <Grid className={classes.intro}>
          <Typography variant="h5" className={classes.newComponents}>
            What's the average footfall traffic in your area ?{" "}
          </Typography>

          <Typography variant="body1" display="block" className={classes.text}>
            Enter your address/postcode or drop a pin into the map to figure out
            the average number of visitors that are within a 5 minutes walking
            range, the average weekly distribution of visits or how the visits
            changed last year.
          </Typography>
          <Typography variant="body1" display="block" className={classes.text}>
            This is a demo developed by{" "}
            <Link href="https://carto.com/" target="_blank">
              CARTO
            </Link>
            .
          </Typography>
          <Typography variant="body1" display="block" className={classes.text}>
            If you want to know more about how you could have something like
            this,{" "}
            <Link href="https://carto.com/request-live-demo/" target="_blank">
              contact us
            </Link>
            .
          </Typography>
        </Grid>
      </Grid>
    );
  }
}
